import './_style.scss';

const ClosableChip = ({ text, onClick }) => {

  return (
    <span className='closable-chip'>
      { text }
      <button type="button" onClick={onClick}><span
        aria-hidden="true">×</span><span
        className="sr-only">Close</span>
      </button>
    </span>
  );
}

export default ClosableChip;
